

<mat-toolbar-row *ngIf='isList'>
    <mat-form-field >
      <mat-label>Search</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="{{ 'inputs.search' | translate }}" #input>
    </mat-form-field>
  
    <div fxFlex fxLayout="row" fxLayoutAlign="end center">
      <ul fxLayout="row" fxLayoutGap="20px">
        <li>
          <button mat-button (click)="newLine()">
            <mat-icon>add</mat-icon>
            {{ 'inputs.add_line' | translate }}
          </button>
        </li>
      </ul>
    </div>
  </mat-toolbar-row>
  
  
  
  
  <div class="media-body">
    
    <div *ngIf='isList'>
      <table mat-table [dataSource]="dataSource" matSort>
                
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'tables.name' | translate }} </th>
          <td mat-cell *matCellDef="let element"(click)="goTo(element.id)"> {{element.name}} </td>
        </ng-container>
        <ng-container matColumnDef="stage">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'tables.stage' | translate }} </th>
            <td mat-cell *matCellDef="let element"(click)="goTo(element.id)"> {{element.stage_name}} </td>
          </ng-container>
          <ng-container matColumnDef="grade">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'tables.grade' | translate }} </th>
            <td mat-cell *matCellDef="let element"(click)="goTo(element.id)"> {{element.grade_name}} </td>
          </ng-container>
  
        <ng-container matColumnDef="modification_date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header fxHide.lt-sm> {{ 'tables.modification_date' | translate }} </th>
          <td mat-cell *matCellDef="let element" (click)="goTo(element.id)" fxHide.lt-sm> {{element.modification_date |  date: 'yyyy-MM-dd H:mm:ss'}} </td>
        </ng-container>
  
        <ng-container matColumnDef="actions"class="actionsColumn">
          <th mat-header-cell *matHeaderCellDef> {{ 'tables.actions' | translate }} </th>
          <td mat-cell *matCellDef="let element"> 
            <button mat-icon-button matTooltip="Click to Delete" class="iconbutton"
            (click)="delete(element.id)" color="warn">
            <mat-icon>delete</mat-icon>
          </button>
            <button mat-icon-button matTooltip="{{'inputs.edit' | translate}}"
              (click)="goTo(element.id)">
              <mat-icon>edit</mat-icon>
            </button>
           
        </td>
        </ng-container>
      
  
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No data found</td>
      </tr>
      </table>
  
      <mat-paginator [pageSizeOptions]="[100, 10, 20,50]" showFirstLastButtons></mat-paginator>
  
  
    </div>
  
  
  
    
    <div *ngIf='!isList'class="content" [formGroup]="lineForm">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <button (click)="goBack()" title="{{ 'inputs.back' | translate }}" mat-icon-button>
              <mat-icon>keyboard_backspace</mat-icon>
              {{ 'inputs.back' | translate }}
            </button>
            <h1 *ngIf='!isList'>{{line_name}}</h1>
            <div *ngIf='!isList && !isNew'>
                {{ 'inputs.creation_date' | translate }}: {{creation_date | date:'d/M/Y, H:mm:ss'}} <br>
                {{ 'inputs.modification_date' | translate }}: {{modification_date | date:'d/M/Y, H:mm:ss'}} 
            </div>
  
            <div class="contenedor" [formGroup]="lineForm" *ngIf='!isList' >
              <input matInput [hidden]="true" [formControlName]="'id'" type="text" placeholder="id">
              <mat-form-field>
                <input matInput required [formControlName]="'name'" type="text" placeholder="{{ 'inputs.name' | translate }}">
              </mat-form-field>
  
              <mat-form-field appearance="legacy">
                <mat-label>{{ 'inputs.stage' | translate }}</mat-label>
                <mat-select matNativeControl [formControlName]="'stages'">
                  <mat-option *ngFor="let stage of stages" [value]="stage.id">
                    {{stage.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="legacy">
                <mat-label>{{ 'inputs.grade' | translate }}</mat-label>
                <mat-select matNativeControl [formControlName]="'grades'">
                  <mat-option *ngFor="let grade of grades" [value]="grade.id">
                    {{grade.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
             
        
              
            </div>
            <div class="float-button-container" *ngIf='!isList'>
              <button mat-fab color="primary" aria-label="save" (click)="saveLine($event)">
                <mat-icon>save</mat-icon>
              </button>
            </div>
          </div>
          </div>
          </div>
    </div>
    <!-- <div class="float-button-container" *ngIf='isList'>
      <button mat-fab color="primary" aria-label="add" (click)="newLine()">
        <mat-icon>plus_one</mat-icon>
      </button>
    </div> -->
    <div class="float-button-container" *ngIf='!isList'>
      <button mat-fab color="primary" aria-label="save" (click)="saveLine($event)">
        <mat-icon>save</mat-icon>
      </button>
    </div>
  </div>